const API_BASE_URL = process.env.API_BASE_URL || '';
// console.log("API_BASE_URL = ", API_BASE_URL);

export function getCookie(name) {
    // First method - parsing cookie string
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    let result = null;

    if (parts.length === 2) {
        result = parts.pop().split(';').shift();
    }

    // Second method - using regex for maximum compatibility
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    const regexResult = match ? match[2] : null;

    // console.log(`getCookie('${name}') - Method 1 result: ${result}, Method 2 result: ${regexResult}`);

    // Return the result from either method
    return result || regexResult;
}

export function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/;SameSite=Lax`;
    // console.log(`Cookie set: ${name}=${value}, expires in ${days} days`);
    // console.log("Current cookies:", document.cookie);
}

export function clearCookies() {
    document.cookie = "access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "username=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "nickname=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "first_name=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "last_name=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "slug=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie = "photo=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

export function setProfileCookies(profile) {
    setCookie('id', profile.id)
    setCookie('username', profile.username)
    setCookie('nickname', profile.nickname)
    setCookie('first_name', profile.first_name)
    setCookie('last_name', profile.last_name)
    setCookie('slug', profile.slug)
    setCookie('photo', profile.photo)
}

// Function to handle the API request
export async function apiClient(endpoint, options = {}, onSuccess, onError) {
    const accessToken = getCookie('access_token');
    const refreshToken = getCookie('refresh_token');
    const notJSON = options.notJSON !== false;

    const headers = {
        ...options.headers
    };

    if (!notJSON) {
        headers['Content-Type'] = 'application/json';
    }

    const useToken = options.useToken !== false;

    if (useToken && accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
    }

    const requestOptions = {
        ...options,
        headers: headers,
        body: options.body
    };

    const url = `${API_BASE_URL}${endpoint}`;

    await fetch(url, requestOptions)
        .then(response => {
            if (response.ok) {
                return response.json().then(data => onSuccess(data));
            } else if (response.status === 401 && refreshToken) {
                return refreshAccessToken(refreshToken, url, options, onSuccess, onError);
            } else {
                return response.json().then(errData => onError(errData));
            }
        })
        .catch(err => {
            if (onError) onError(err);
        });
}

async function refreshAccessToken(refreshToken, originalUrl, originalOptions, onSuccess, onError) {
    // Combine the base URL and endpoint
    const url = `${API_BASE_URL}/token/refresh'`;

    await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ token: refreshToken })
    })
        .then(response => {
            if (response.ok) {
                return response.json().then(data => {
                    document.cookie = `access_token=${data.access_token}; path=/; secure`;
                    return apiClient(originalUrl, originalOptions, onSuccess, onError);
                });
            } else {
                // Clear the access and refresh tokens
                clearCookies();
                // If refresh fails, redirect to login
                window.location.href = '/accounts/login/';
            }
        })
        .catch(() => {
            window.location.href = '/accounts/login/';
        });
}
